import {FormFieldItem, getUserData, languages, timeFormats} from '@common'
import {FormFieldType, Language, TranslationKey} from '@enums'
import {Typography} from '@mui/material'
import {getUserTimeFormatAtom, pageLinksAtom, setUserLanguageAtom, setUserTimeFormatAtom} from '@state'

import React, {useEffect} from 'react'

import {TitleLink} from 'common/types'
import {config} from 'constants/config'
import i18next from 'i18next'
import {useAtom, useAtomValue, useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

import {CustomRenderWrapper} from './style'

export function useSettingsModel() {
  const settingsData = config
  const currentUser = getUserData()
  const setTitleLinks = useSetAtom(pageLinksAtom)
  const [, setUserLanguage] = useAtom(setUserLanguageAtom)

  const {t} = useTranslation()
  const getUserTimeFormat = useAtomValue(getUserTimeFormatAtom)

  const userTimeFormat = getUserTimeFormat(currentUser.id)

  const [, setUserTimeFormat] = useAtom(setUserTimeFormatAtom)

  const titleLinks: TitleLink[] = [{title: t(TranslationKey.Settings)}]

  useEffect(() => {
    setTitleLinks(titleLinks)
  }, [titleLinks])

  /**
   * A function for custom rendering of the DropdownItem
   */
  const renderValue = () => {
    const selectedLanguage = languages(t).find(item => item.value === i18next.language)

    return (
      <CustomRenderWrapper>
        <Typography fontWeight={'bold'}>{selectedLanguage?.label}</Typography>
        {selectedLanguage?.icon}
      </CustomRenderWrapper>
    )
  }

  /**
   * Settings form fields configuration
   */
  const settingsFields: FormFieldItem[] = [
    {
      fieldType: FormFieldType.DROPDOWN,
      width: 200,
      value: userTimeFormat,
      label: t(TranslationKey['Time format']),
      customStyle: {height: '30px', marginTop: '-2px'},
      items: timeFormats,
      onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setUserTimeFormat({userId: currentUser.id, timeFormat: event.target.value})
      },
    },
    {
      fieldType: FormFieldType.DROPDOWN,
      width: 200,
      value: i18next.language,
      label: t(TranslationKey.Language),
      customStyle: {height: '30px', marginTop: '-2px'},
      renderValue: renderValue,
      items: languages(t),
      onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        i18next.changeLanguage(event.target.value as string)
        setUserLanguage({userId: currentUser.id, language: event.target.value as Language})
      },
    },
  ]

  /**
   * Information form fields configuration
   */
  const informationFields: FormFieldItem[] = [
    {
      fieldType: FormFieldType.LABEL,
      label: t(TranslationKey.Name),
      text: settingsData.name,
    },
    {
      fieldType: FormFieldType.LABEL,
      label: t(TranslationKey['UI version']),
      text: settingsData.version.split(' ').join('.'),
    },
    {
      fieldType: FormFieldType.LABEL,
      label: t(TranslationKey['BE version']),
      text: settingsData.version.split(' ').join('.'),
    },
    {
      fieldType: FormFieldType.LABEL,
      label: t(TranslationKey['Last update']),
      text: settingsData.lastUpdate,
    },
    {
      fieldType: FormFieldType.LABEL,
      label: t(TranslationKey.Environment),
      text: settingsData.environment,
    },
  ]

  return {settingsFields, informationFields, t}
}
